import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TableData } from '../../../../../table-overlay/table-overlay';

@Component({
  selector: 'ct-extraction-table-overlay-back-button',
  imports: [],
  templateUrl: './table-overlay-back-button.component.html',
})
export class TableOverlayBackButtonComponent {
  @Input({ required: true }) tableData!: TableData;
  @Output() buttonClicked = new EventEmitter<void>();
}
